import { Injectable } from "@angular/core";
import { InsightProvider } from "../telephony.provider";
import { FunctionLifeCycle } from "../telephonyutils";
import { HttpClient } from "@angular/common/http";
import { getContext } from "@app/core";

@Injectable({ providedIn: 'root' })
export class IbexInsightProvider extends InsightProvider {
    constructor(private httpClient: HttpClient) {
        super();
    }
    init(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): void {
        throw new Error("Method not implemented.");
    }
    clientStats(lifecyle: FunctionLifeCycle, from: string, to: string, campaign: any) {
        let url = `/insights/clientstats`;
        if (campaign.Code !== 'All') {
            url += `?campaign=${campaign.Code}`;
        }
        return this.httpClient.disableLoader().get(url, { context: getContext('telephony') });
    }
    forceLogOff(lifecyle?: FunctionLifeCycle) {
        throw new Error("Method not implemented.");
    }

}